import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { v4 as uuid } from 'uuid';
import MatrixRow from './MatrixRow';
import MatrixHeader from './MatrixHeader';
import ServicePeriodInfo from './ServicePeriodInfo';
import styles from './Matrix.scss';
import { subscriptionPick } from '../../../actions/subscriptions';
import { withServices } from '../../../enhancers';
import classNames from 'classnames';

class Matrix extends Component {
    state = {
      serviceInfo: this.props.services[this.props.service],
    };

    handleSubscriptionButtonClick = (periodUnit, campaignUrl) => {
      const service = this.state.serviceInfo.data.find(service => service.periodUnit === periodUnit);
      this.props.subscriptionPick(service);
      this.openPayment(campaignUrl);
    };

    handleYearlySubscriptionButton = (campaignUrl) => {
      this.handleSubscriptionButtonClick('Years', campaignUrl);
    };

    handleMonthlySubscriptionButton = (campaignUrl) => {
      this.handleSubscriptionButtonClick('Months', campaignUrl);
    };

    openPayment = campaignUrl =>
      this.props.history.push(campaignUrl || '/subscriptions/payment');

    render() {
      const {
        matrix, service, isShortList, handleShowMoreLessButtonClick,
      } = this.props;
      const { serviceInfo } = this.state;

      const serviceYearly = serviceInfo.data[1];
      const serviceMonthly = serviceInfo.data[0];
      const isMobile = document.body.clientWidth < 768;

      return (
        <div className={classNames(styles.root, service)}>
          <div>
            <MatrixHeader service={service} />
            <div className={styles.showMore} onClick={handleShowMoreLessButtonClick}>
              <span>{isShortList ? 'View all features' : 'Show less'}</span>
              {isShortList ? (
                <img
                  src="/svgs/plus_icon.svg"
                  className={styles.showMoreLessIcon}
                  height="16"
                  width="16"
                  alt="plus icon"
                            />
                        ) : (
                          <img
                            src="/svgs/minus_icon.svg"
                            className={styles.showMoreLessIcon}
                            height="16"
                            width="16"
                            alt="minus icon"
                            />
                        )}
            </div>
            <div className={classNames({ [styles.martrixRowsWrapper]: !isShortList })}>
              {matrix.map((row, index) => (
                <MatrixRow
                  key={uuid()}
                  data={row}
                  service={service}
                  index={index}
                  isShortList={isShortList}
                  isMobile={isMobile}
                            />
                        ))}
              {!isShortList && (
                <div className={styles.showLessWrapper}>
                  <svg className={styles.showLessArrow}>
                    <use xlinkHref="#arrow-up" />
                  </svg>
                </div>
                        )}
            </div>
          </div>
          <div className={styles.serviceInfoWrapper}>
            <ServicePeriodInfo
              service={serviceYearly}
              handleClick={this.handleYearlySubscriptionButton}
              subscribtionPackage={service}
                    />
            <ServicePeriodInfo
              service={serviceMonthly}
              handleClick={this.handleMonthlySubscriptionButton}
              subscribtionPackage={service}
                    />
          </div>
        </div>
      );
    }
}

Matrix.propTypes = {
  service: PropTypes.string.isRequired,
  matrix: PropTypes.arrayOf(PropTypes.shape({
    description: PropTypes.string.isRequired,
    expandedDescription: PropTypes.string.isRequired,
    packages: PropTypes.array.isRequired,
  })).isRequired,
  isShortList: PropTypes.bool.isRequired,
  handleShowMoreLessButtonClick: PropTypes.func.isRequired,
};

function mapStateToProps({ breakpoint, matrix: { options } }) {
  return {
    breakpoint: breakpoint.current.code,
    matrix: options,
  };
}

const MatrixContainer = compose(
  withRouter,
  connect(
    mapStateToProps,
    { subscriptionPick },
  ),
)(withServices(Matrix, { trackBreakpointChange: false }));

export { Matrix, MatrixContainer as default };
